import { render, staticRenderFns } from "./PleaseConnect.vue?vue&type=template&id=538b5c2e&"
import script from "./PleaseConnect.vue?vue&type=script&lang=js&"
export * from "./PleaseConnect.vue?vue&type=script&lang=js&"
import style0 from "./PleaseConnect.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports